import React from 'react'
import PropTypes from 'prop-types'

const Heart = ({ width = 32, height = 32 }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 130 133"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <defs>
      <path
        d="M87.8479978,124.183997 C79.1493314,116.31333 72.7039982,105.757331 68.7266649,94.7239976 L68.7266649,94.7239976 C64.6599984,111.150664 51.3199987,124.94533 35.0386658,129.56133 L35.0386658,129.56133 C30.2573326,130.915997 25.1413327,131.519997 20.3199995,130.318663 L20.3199995,130.318663 C13.6466663,128.655997 8.14133313,123.60533 4.85599988,117.56133 L4.85599988,117.56133 C-0.707999982,107.326664 -0.257333327,94.6159976 3.74933324,83.6773312 L3.74933324,83.6773312 C7.75466647,72.7386648 14.9719996,63.2853318 22.6266661,54.505332 L22.6266661,54.505332 C40.6333323,33.8453325 61.6853318,15.8426663 84.8893312,1.25809869 L84.8893312,1.25809869 C85.2319979,1.04266664 124.38533,62.4893318 129.11733,98.6359975 L129.11733,98.6359975 C129.95333,105.015997 130.28133,111.595997 128.587997,117.802664 L128.587997,117.802664 C126.891997,124.010664 122.910664,129.84933 117.04533,132.494663 L117.04533,132.494663 C114.626664,133.58533 112.105331,134.067997 109.558664,134.067997 L109.558664,134.067997 C101.810664,134.066663 93.8306643,129.598663 87.8479978,124.183997"
        id="path-1"
      ></path>
    </defs>
    <g id="heart" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g
        id="g12"
        transform="translate(65.333323, 66.853358) scale(1, -1) translate(-65.333323, -66.853358) translate(-0.000008, -0.479973)"
      >
        <g id="g14-Clipped">
          <mask id="mask-2" fill="white">
            <use xlinkHref="#path-1"></use>
          </mask>
          <g id="path16"></g>
          <g id="g14" mask="url(#mask-2)">
            <g transform="translate(-25.333333, -29.333333)">
              <g id="g20" transform="translate(2.080667, 107.343597)">
                <path
                  d="M0,17.3333329 L0,0.110666664 C16.6279996,5.31599987 34.6173325,6.17466651 51.1559987,11.3439997 C37.2826657,24.5959994 18.6906662,22.5666661 0,17.3333329"
                  id="path22"
                  fill="#E8DCC7"
                  fillRule="nonzero"
                ></path>
              </g>
              <g id="g24" transform="translate(42.953066, 118.149597)">
                <path
                  d="M34.6666658,73.3333315 L15.5093329,73.3333315 C23.9013327,50.7053321 22.7386661,24.5053327 0.165333329,7.33199982 C3.74399991,5.75733319 7.13733315,3.54533324 10.2839997,0.538666653 C13.489333,1.53999996 16.6399996,2.70133327 19.7159995,4.09066656 C45.8119989,15.3759996 35.8733324,47.5239988 34.6666658,73.3333315"
                  id="path26"
                  fill="#C9E3D0"
                  fillRule="nonzero"
                ></path>
              </g>
              <g id="g28" transform="translate(1.128933, 123.482930)">
                <path
                  d="M57.3333319,67.9999983 L0.951999976,67.9999983 L0.951999976,1.19466664 C15.4013329,5.23999987 29.7919993,7.36399982 41.9893323,1.99866662 C64.5626651,19.1719995 65.7253317,45.3719989 57.3333319,67.9999983"
                  id="path30"
                  fill="#6FC090"
                  fillRule="nonzero"
                ></path>
              </g>
              <g id="g32" transform="translate(1.444000, 60.142398)">
                <path
                  d="M70.6666649,43.9999989 C73.0279982,51.0826654 75.3879981,58.9506652 80.1093313,64.4586651 C95.6906643,83.4253312 112.434664,107.058664 109.259997,131.339997 L76.1759981,131.339997 C77.3826647,105.530664 87.3213312,73.3826648 61.2239985,62.0973318 C42.2786656,53.541332 20.4866662,53.5266653 0.637333317,47.3106655 L0.637333317,0.934666643 C15.4599996,10.1279997 30.9599992,17.6946662 47.8479988,24.3293327 C57.2906652,27.4759993 65.9453317,34.5573325 70.6666649,43.9999989"
                  id="path34"
                  fill="#BE9431"
                  fillRule="nonzero"
                ></path>
              </g>
              <g id="g36" transform="translate(1.527333, 1.709467)">
                <path
                  d="M86.6666645,71.9999982 C55.9213319,68.8773316 26.222666,52.325332 0.55333332,34.7519991 L0.55333332,0.535999987 L49.2839988,0.535999987 C51.1733321,20.9546661 65.686665,38.4186657 79.2386647,54.4346653 C83.4373312,59.8333318 86.2559978,65.6893317 86.6666645,71.9999982"
                  id="path38"
                  fill="#CE7A69"
                  fillRule="nonzero"
                ></path>
              </g>
              <g id="g40" transform="translate(49.839865, 2.244667)">
                <path
                  d="M49.3333321,72 C45.6626655,72.0279982 42.0013323,71.8346649 38.3546657,71.4653315 C37.9439991,65.1533317 35.1239991,59.2973319 30.9266659,53.8999987 C17.3746662,37.8839991 2.86133326,20.4199995 0.971999976,0 L28.9973326,0 C30.3773326,23.3026661 38.9413324,45.9773322 54.8586653,64.1319984 C52.9239987,66.666665 51.0746654,69.2799983 49.3333321,72"
                  id="path42"
                  fill="#105542"
                  fillRule="nonzero"
                ></path>
              </g>
              <g id="g44" transform="translate(78.031198, 1.042800)">
                <path
                  d="M26.666666,65.3333317 C10.7493331,47.1799988 2.18666661,24.5039994 0.805333313,1.20266664 L111.025331,1.20266664 C80.619998,19.9706662 48.0479988,37.2933324 26.666666,65.3333317"
                  id="path46"
                  fill="#568C58"
                  fillRule="nonzero"
                ></path>
              </g>
              <g id="g48" transform="translate(98.389331, 2.245333)">
                <path
                  d="M90.6666644,0 L98.8306642,0 L98.8306642,23.5866661 C81.439998,39.4013323 62.0386651,52.401332 40.603999,62.5546651 C27.3599993,69.0759983 14.0079996,71.8959982 0.78399998,72 C21.7733328,39.2013324 57.5133319,20.4653328 90.6666644,0"
                  id="path50"
                  fill="#E2E4D3"
                  fillRule="nonzero"
                ></path>
              </g>
              <g id="g52" transform="translate(110.119731, 71.246532)">
                <path
                  d="M1.3333333,22.6666661 C1.3333333,20.3053328 4.48133322,17.1586662 6.8426665,15.5853329 C32.2693325,4.22399989 60.3026652,4.76533321 87.0999978,0.0759999981 L87.0999978,37.6933324 C72.3613315,37.8999991 57.9639986,38.5413324 43.0359989,39.1906657 C28.086666,40.763999 0.546666653,43.9119989 1.3333333,22.6666661"
                  id="path54"
                  fill="#EF6224"
                  fillRule="nonzero"
                ></path>
              </g>
              <g id="g56" transform="translate(73.473998, 100.480931)">
                <path
                  d="M49.3333321,9.3333331 C43.2133323,22.7253328 35.2533325,35.4346658 23.4719994,44.8146655 C18.7506662,37.4866657 13.349333,30.5359992 8.0799998,24.1199994 C4.83599988,20.3346662 2.7066666,15.4373329 0.92533331,10.4453331 C13.9199997,9.05066644 26.8279993,5.56533319 39.083999,0.695999983 C40.8666656,5.16799987 44.6333322,7.82533314 49.3333321,9.3333331"
                  id="path58"
                  fill="#F79E82"
                  fillRule="nonzero"
                ></path>
              </g>
              <g id="g60" transform="translate(116.746130, 25.777199)">
                <path
                  d="M2.6666666,59.9999985 C1.80533329,55.5226653 0.78399998,51.0439987 0.422666656,46.5666655 C7.70399981,45.0533322 14.9919996,42.5946656 22.2479994,39.0226657 C43.6826656,28.8693326 63.0839984,15.8693329 80.4733313,0.0559999986 L80.4733313,45.5453322 C54.533332,50.0853321 27.4373326,49.7226654 2.6666666,59.9999985"
                  id="path62"
                  fill="#AADBCD"
                  fillRule="nonzero"
                ></path>
              </g>
              <g id="g64" transform="translate(67.733065, 72.259598)">
                <path
                  d="M6.6666665,38.6666657 C5.85599985,36.3919991 5.11599987,34.0986658 4.37733322,31.8826659 C3.44399991,30.0173326 2.35333327,28.2479993 1.1373333,26.578666 C8.44666646,19.8239995 12.3186664,9.97733308 11.2173331,0.12533333 C18.2786662,1.4453333 25.4133327,2.11066661 32.5826659,1.96933328 C32.4719992,12.7706663 31.9586659,23.4813327 30.1173326,33.9679992 C22.4159994,36.1973324 14.557333,37.8199991 6.6666665,38.6666657"
                  id="path66"
                  fill="#FED9B4"
                  fillRule="nonzero"
                ></path>
              </g>
              <g id="g68" transform="translate(96.746131, 71.110532)">
                <path
                  d="M22.6666661,14.6666663 C21.8479995,15.0066663 21.0293328,15.3573329 20.2159995,15.7213329 C17.8559996,17.2946662 14.7066663,20.4426662 14.7066663,22.8026661 C14.6026663,25.638666 15.0039996,28.0399993 15.8106663,30.0666659 C10.9986664,31.9786659 6.08266651,33.6733325 1.10399997,35.1159991 C2.94533326,24.6306661 3.45866658,13.9199997 3.57066658,3.11733326 C9.17199977,3.00666659 14.7959996,2.40266661 20.4226662,1.2333333 C20.7839995,5.71066652 21.8053328,10.1893331 22.6666661,14.6666663"
                  id="path70"
                  fill="#CD3C36"
                  fillRule="nonzero"
                ></path>
              </g>
              <g id="g72" transform="translate(0.870400, 36.171066)">
                <path
                  d="M67.9999983,62.6666651 C63.0626651,55.8879986 55.9986653,50.8253321 48.4213321,48.2999988 C31.5333325,41.6653323 16.0333329,34.0999991 1.21066664,24.906666 L1.21066664,0.290666659 C24.2986661,16.0946663 50.6439987,31.0839992 78.079998,36.2133324 C79.1813314,46.0666655 75.3093315,55.9133319 67.9999983,62.6666651"
                  id="path74"
                  fill="#000000"
                  fillRule="nonzero"
                ></path>
              </g>
              <g id="g76" transform="translate(95.822931, 107.770664)">
                <path
                  d="M57.3333319,2.6666666 C72.2599982,2.01733328 86.6586645,1.37599997 101.397331,1.16799997 L101.397331,22.5066661 C80.4453313,11.2319997 56.4266653,7.53199981 35.3026658,23.1253328 C14.6106663,38.643999 29.3133326,63.1853318 31.8306659,83.7119979 L14.881333,83.7119979 C16.9813329,67.6439983 10.3586664,51.861332 1.12266664,37.5253324 C12.905333,28.1453326 20.8639995,15.4359996 26.9839993,2.04399995 C36.1173324,4.97333321 48.7826654,3.56666658 57.3333319,2.6666666"
                  id="path78"
                  fill="#6A9BCF"
                  fillRule="nonzero"
                ></path>
              </g>
              <g id="g80" transform="translate(119.837197, 126.149597)">
                <path
                  d="M75.9999981,65.3333317 L7.8159998,65.3333317 C5.29999987,44.8053322 -9.40399976,20.2653328 11.2879997,4.74666655 C13.549333,3.07599992 15.8466663,1.63999996 18.1679995,0.398666657 C25.0693327,30.2013326 49.2666654,50.9906654 75.9999981,65.3333317"
                  id="path82"
                  fill="#BF9431"
                  fillRule="nonzero"
                ></path>
              </g>
              <g id="g84" transform="translate(138.005197, 119.881997)">
                <path
                  d="M0,6.6666665 C19.3559995,-3.68666657 40.5066657,0.327999992 59.2146652,10.3959997 L59.2146652,71.6013315 L57.8319986,71.6013315 C31.0986659,57.2586652 6.90133316,36.4693324 0,6.6666665"
                  id="path86"
                  fill="#E4B52D"
                  fillRule="nonzero"
                ></path>
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
)

Heart.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number,
}

export default Heart
